import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../../sharedcomponents/5templates/detailCards/listBucketCard'
import useService from './useService'
import LeftChild from './LeftChild'
const ServiceDetail = ({ createMode }) => {
  const { serviceId, type } = useParams()

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)

  const {
    typeIdToDisplayName,
    useGetOneServiceQuery,
    fetchAuxiliaryRecords,
    bulkUpdateServicesCallBack,
    upsertServiceCallback,
    resourceTypes,
    removeService,
    finalAuxiliaryRecords,
    makeInMemoryServiceRecord,
    suspendService,
    loading: updateServiceLoading
  } = useService()

  const {
    data: { data: rawServiceRecord } = { data: {} },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneServiceQuery(
    {
      include: ['counts'],
      id: serviceId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )

  const loading = useMemo(() => updateServiceLoading || isLoading, [updateServiceLoading, isLoading])

  const primaryServiceRecord = createMode
    ? makeInMemoryServiceRecord(type)
    : JSON.parse(JSON.stringify(rawServiceRecord))
  primaryServiceRecord.refetch = refetch

  return (
    <DetailWrapper
      entityDisplayName={'Service'}
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={primaryServiceRecord}
      isLoading={!createMode && (loading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertServiceCallback}
      bulkUpdateCallBack={bulkUpdateServicesCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
    >
      {({ formikProps, activationChangeCallback, deleteEntityCallback }) => {
        return (
          <>
            <div style={{ float: 'left', width: '34%' }}>
              <LeftCard
                entityDisplayName={'Service'}
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={deleteEntityCallback(removeService)}
                activationChangeCallback={activationChangeCallback(suspendService)}
                listOfTypes={resourceTypes}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
              >
                <LeftChild
                  formikProps={formikProps}
                  editMode={detailEditMode}
                  createMode={createMode}
                  serviceTypes={finalAuxiliaryRecords?.serviceTypes}
                  serviceCategories={finalAuxiliaryRecords?.serviceCategories}
                />
              </LeftCard>
            </div>
            <div style={{ float: 'left', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              />
            </div>
            <div style={{ float: 'right', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.tercero}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default React.memo(ServiceDetail)
